// extracted by mini-css-extract-plugin
module.exports = {"tableCell":"style_tableCell__1UrwH","start":"style_start__T_7tE","end":"style_end__0XcYw","cellStart":"style_cellStart__Mdz_r","cellEnd":"style_cellEnd__1kY7j"};